import React from "react";
import { Card, CardContent, Typography, Link, Box } from "@mui/material"; // Material UI bileşenlerini varsayıyoruz, projenizde farklı olabilir
import TwitterIcon from '@mui/icons-material/Twitter'; // Twitter ikonu

// Tweet tarihini formatlayan yardımcı fonksiyon
const formatTweetDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  return new Date(dateString).toLocaleDateString('tr-TR', options);
};

const Tweets = ({ tweets }) => {
  if (!tweets || tweets.length === 0) {
    return <Typography>Yüklenecek tweet bulunamadı.</Typography>; // Veya bir yükleniyor göstergesi
  }

  return (
    <Box sx={{ marginTop: 4 }}>
       <Typography variant="h5" component="h2" gutterBottom sx={{ textAlign: 'center', marginBottom: 3, fontWeight: 'bold' }}>
         Son Tweetler <TwitterIcon sx={{ verticalAlign: 'middle', color: '#1DA1F2' }}/>
       </Typography>
      {tweets.map((tweet) => (
        <Card key={tweet.id} sx={{ marginBottom: 2, boxShadow: 3 }}>
          <CardContent>
            {/* Tweet metnini HTML olarak render et */}
            <Typography
              variant="body1"
              component="div" // div olarak render et
              dangerouslySetInnerHTML={{ __html: tweet.text }}
              sx={{ marginBottom: 1, lineHeight: 1.6 }} // Satır yüksekliği ekledik
            />
            <Typography variant="caption" color="text.secondary">
              {formatTweetDate(tweet.created_at)} -{' '}
              <Link
                href={`https://twitter.com/i/web/status/${tweet.id}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#1DA1F2', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              >
                Twitter'da Görüntüle
              </Link>
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default Tweets;
